var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 9.375L12.75 7.6875C12.8379 7.57031 12.9785 7.5 13.125 7.5H16.875C17.0215 7.5 17.1621 7.57031 17.25 7.6875L18.5156 9.375H20.625C20.8828 9.375 21.0938 9.58594 21.0938 9.84375C21.0938 10.1016 20.8828 10.3125 20.625 10.3125H20.0918L19.3418 20.7598C19.2715 21.7383 18.4043 22.5 17.4727 22.5H12.5273C11.543 22.5 10.7285 21.7383 10.6582 20.7598L9.9082 10.3125H9.375C9.11719 10.3125 8.90625 10.1016 8.90625 9.84375C8.90625 9.58594 9.11719 9.375 9.375 9.375H11.4844ZM12.6562 9.375H17.3438L16.6406 8.4375H13.3594L12.6562 9.375ZM19.1484 10.3125H10.8516L11.5898 20.6895C11.625 21.1816 12.0352 21.5625 12.5273 21.5625H17.4727C17.9648 21.5625 18.375 21.1816 18.4102 20.6895L19.1484 10.3125ZM30 15C30 23.2852 23.2852 30 15 30C6.71484 30 0 23.2852 0 15C0 6.71484 6.71484 0 15 0C23.2852 0 30 6.71484 30 15ZM15 0.9375C7.23633 0.9375 0.9375 7.23633 0.9375 15C0.9375 22.7637 7.23633 29.0625 15 29.0625C22.7637 29.0625 29.0625 22.7637 29.0625 15C29.0625 7.23633 22.7637 0.9375 15 0.9375Z",
    fill: "#F25252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.a2d71a278af657657e6471209d4015a4.svg";
export { ForwardRef as ReactComponent };